import React from 'react'
import Article from '../Article';
import MyComponent from '../MyComponent';
import ArticleContainer from '../ArticleContainer';
import shortid from "shortid";
import SubMenu from './SubMenu';

const Menu = ({ rule }) => {
    const menu = rule?.ContentRuleZone?.[0];
    return (
        <li class="main-menu-item menu-item-even">
            <a class="menu-link ca-main-menu-link" href="#">{menu?.attributes?.displayName ?? ""}</a>
            <span class="nav-click"><i class="bi bi-bars"></i></span>
            <ul class="sub-menu menu-odd">
                <li class="sub-menu-item menu-item-odd">
                    <div class="row">
                        {menu?.contents?.ContentFolderZone?.[0]?.childRules?.map(subMenu => (
                           <SubMenu key={shortid.generate()} subMenu={subMenu} />
                        ))}
                    </div>
                </li>
            </ul>
        </li>

    )
}

export default Menu